import { Accordion, SelectField } from '@ubeya/shared-web/components';
import React, { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { FieldsContainer, SectionContent } from '../styled';

const TimeSheets = () => {
  const { t } = useContext(ConfigContext);

  return (
    <Accordion defaultOpenRows={{ 0: true }}>
      <Accordion.Item title={t('invoicingSettings__timesheets')}>
        <SectionContent>
          <FieldsContainer $count={1}>
            <SelectField
              name="invoicing.timesheetsToBeApprovedBy"
              title={t('invoicingSettings__timesheetsToBeApprovedBy')}
              isMulti={false}
              options={[
                { label: 'My Admin', value: 'My Admin' },
                { label: 'Client', value: 'Client' }
              ]}
            />
          </FieldsContainer>
        </SectionContent>
      </Accordion.Item>
    </Accordion>
  );
};

export default TimeSheets;
